// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1xeot","containerItemsCenter":"Skeleton_containerItemsCenter__59VLB"};